import { Injectable } from '@angular/core';
import { BaseDAO } from './baseDAO';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { Observable } from 'rxjs';
import { HttpHeaders } from '@angular/common/http';
import { BuyflowProductOffering } from 'anchor-shared/lib/model/interface/buyflowProductOffering';
import { ProductOffering } from 'anchor-shared/lib/model/entity/productOffering';

@Injectable()
export class ProductOfferingDAO extends BaseDAO<ProductOffering> {
  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.PRODUCT_OFFERING);
  }

  public createProductOffering(
    vesselId: number,
    productOffering: Partial<ProductOffering>,
  ): Observable<ProductOffering> {
    let url: string =
      this.apiHelper.getServiceName() + this.getResource() + '/' + vesselId;
    let method = 'POST';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<ProductOffering>(
      url,
      method,
      null,
      productOffering,
      headers,
    );
  }

  public update(
    vesselId: number,
    productOfferingId: number,
    partialProductOffering: Partial<ProductOffering>,
  ): Observable<ProductOffering> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      `/vessel/${vesselId}/product/${productOfferingId}`;
    const method = 'PUT';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    return this.apiHelper.apiCall<ProductOffering>(
      url,
      method,
      null,
      partialProductOffering,
      headers,
    );
  }

  public delete(
    vesselId: number,
    productOfferingId: number,
  ): Observable<ProductOffering> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      `/vessel/${vesselId}/product/${productOfferingId}`;
    let method = 'DELETE';
    let headers: HttpHeaders = this.apiHelper.getDefaultHeader();

    return this.apiHelper.apiCall<ProductOffering>(
      url,
      method,
      null,
      null,
      headers,
    );
  }

  public findByVesselPreferencesId(
    vesselId: number,
    vesselAvailabilityPreferencesId: number,
  ): Observable<ProductOffering[]> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      `/vessel/${vesselId}/vesselPrefs/` +
      vesselAvailabilityPreferencesId;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any[]>(url, method, null, null, headers);
  }

  public findByVesselPreferencesIdForBuyflow(
    vesselId: number,
    vesselAvailabilityPreferencesId: number,
  ): Observable<BuyflowProductOffering[]> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      `/vessel/${vesselId}/buyflow/` +
      vesselAvailabilityPreferencesId;
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any[]>(url, method, null, null, headers);
  }

  public activeProductConflicts(
    vesselId: number,
    vesselPrefsId: number,
    requestProduct: Partial<ProductOffering>,
  ): Observable<any> {
    let url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/vessel/' +
      vesselId +
      '/active/product-conflicts';
    const method = 'POST';
    const data = {
      vesselPrefsId: vesselPrefsId,
      requestProduct: requestProduct,
    };
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any>(url, method, null, data, headers);
  }
}
